<template>
    <div
        class="modal fade text-left"
        :id="id"
    >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel1">
                        {{ localizationStore.translate('fax.dropzone.file.title') }}
                    </h4>
                    <button @click="closeModal(`#${id}`)" type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form action="#" enctype=multipart/form-data class="dropzone dropzone-area" id="upload-documents">
                        <div class="dz-message">Drop files here or click to upload.</div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button @click="closeModal(`#${id}`)" type="button" class="btn btn-primary">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { closeModal, hideModal, openModal } from '../../utilities/_helpers'
    export default {
        props: {
            id: String
        },
        mounted() {
        },
        setup(props) {
            return {
                closeModal: closeModal,
                localizationStore: useLocalizationStore(),
            }
        },
    }
</script>
